import { Type } from "src/utils";

import ServiceEntry from "./service-entry";

/**
 * 提供关于服务容器的功能。
 * @export
 * @class ServiceStorage
 */
export default class ServiceStorage {

    /**
     * 私有服务字典。
     * @private
     * @type {Map<Function, any>}
     * @memberof ServiceStorage
     */
    private _storage: Map<Function, any>;

    /**
     * 静态单实例。
     * @private
     * @static
     * @type {ServiceStorage}
     * @memberof ServiceStorage
     */
    private static _instance: ServiceStorage;

    /**
     * 获取一个服务工厂的单实例。
     * @readonly
     * @static
     * @type {ServiceStorage}
     * @memberof ServiceStorage
     */
    public static get instance(): ServiceStorage {
        if (!this._instance) {
            this._instance = new ServiceStorage();
        }

        return this._instance;
    }

    /**
     * 初始化服务工厂的新实例。
     * @memberof ServiceStorage
     */
    protected constructor() {
        this._storage = new Map<Function, any>();
    }

    /**
     * 注册服务。
     * @param {Function} serviceType 服务类型。
     * @param {*} [service] 服务实例，必须为服务类型的实例，否则会报错。
     * @memberof ServiceStorage
     */
    public register(serviceType: Function, service?: any): void {
        if (!this._storage.has(serviceType)) {
            const { serviceType: st, service: s } = new ServiceEntry(serviceType, service);
            this._storage.set(st, s);
        }
    }

    /**
     * 注销服务。
     * @param {Function} serviceType 要注销的服务类型。
     * @memberof ServiceStorage
     */
    public unregister(serviceType: Function): void {
        if (Type.isEmpty(serviceType)) {
            throw new Error();
        }

        this._storage.delete(serviceType);
    }

    /**
     * 根据指定服务类型获取服务实例。
     * @param {Function} serviceType 服务类型。
     * @returns T
     */
    public resolve<T>(serviceType: Function): T {
        if (Type.isEmpty(serviceType) && !Type.isFunction(serviceType)) {
            throw new Error();
        }

        return this._storage.get(serviceType);
    }

    /**
     * 重新设置存储。
     */
    public reset(): void {
        this._storage = new Map<Function, any>();
    }
}
